import { render, staticRenderFns } from "./BillingDailyStatistics.vue?vue&type=template&id=01f2ac3b"
import script from "./BillingDailyStatistics.vue?vue&type=script&lang=js"
export * from "./BillingDailyStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports